/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Ticket_Not_Found_DescInputs */

const en_verify_ticket_not_found_desc = /** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This ticket does not exist, or payment has not been completed.`)
};

const es_verify_ticket_not_found_desc = /** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ticket no existe o el pago no se ha completado.`)
};

const fr_verify_ticket_not_found_desc = /** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce ticket n'existe pas ou le paiement n'a pas été finalisé.`)
};

const de_verify_ticket_not_found_desc = /** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Ticket existiert nicht oder die Zahlung wurde nicht abgeschlossen.`)
};

const id_verify_ticket_not_found_desc = /** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiket ini tidak ada, atau pembayaran belum diselesaikan.`)
};

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const ja_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const zh_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const ar_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const it_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const ru_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const pt_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/** @type {(inputs: Verify_Ticket_Not_Found_DescInputs) => LocalizedString} */
const ko_verify_ticket_not_found_desc = en_verify_ticket_not_found_desc;

/**
* | output |
* | --- |
* | "This ticket does not exist, or payment has not been completed." |
*
* @param {Verify_Ticket_Not_Found_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_ticket_not_found_desc = /** @type {((inputs?: Verify_Ticket_Not_Found_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Ticket_Not_Found_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_ticket_not_found_desc(inputs)
	if (locale === "es") return es_verify_ticket_not_found_desc(inputs)
	if (locale === "fr") return fr_verify_ticket_not_found_desc(inputs)
	if (locale === "de") return de_verify_ticket_not_found_desc(inputs)
	if (locale === "ja") return ja_verify_ticket_not_found_desc(inputs)
	if (locale === "zh") return zh_verify_ticket_not_found_desc(inputs)
	if (locale === "ar") return ar_verify_ticket_not_found_desc(inputs)
	if (locale === "id") return id_verify_ticket_not_found_desc(inputs)
	if (locale === "it") return it_verify_ticket_not_found_desc(inputs)
	if (locale === "ru") return ru_verify_ticket_not_found_desc(inputs)
	if (locale === "pt") return pt_verify_ticket_not_found_desc(inputs)
	return ko_verify_ticket_not_found_desc(inputs)
});